/* Store Locator — Google Maps integration */
window.StoreLocator = (function () {
  'use strict';

  function escHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildInfoContent(store) {
    var html = '<div class="sl-info-window">';
    html += '<strong class="sl-info-window__name">' + escHtml(store.name) + '</strong>';
    if (store.address) {
      html += '<p class="sl-info-window__address">' + escHtml(store.address).replace(/\n/g, '<br>') + '</p>';
    }
    if (store.phone) {
      html += '<p class="sl-info-window__phone"><a href="tel:' + encodeURIComponent(store.phone) + '">' + escHtml(store.phone) + '</a></p>';
    }
    if (store.hours) {
      html += '<p class="sl-info-window__hours">' + escHtml(store.hours).replace(/\n/g, '<br>') + '</p>';
    }
    if (store.mapsUrl) {
      html += '<a href="' + escHtml(store.mapsUrl) + '" target="_blank" rel="noopener noreferrer" class="sl-info-window__link">Get Directions &#8594;</a>';
    }
    html += '</div>';
    return html;
  }

  function buildMarkerIcon(color) {
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="46" viewBox="0 0 36 46">' +
      '<path d="M18 0C8.059 0 0 8.059 0 18c0 13.5 18 28 18 28S36 31.5 36 18C36 8.059 27.941 0 18 0z" fill="' + color + '"/>' +
      '<circle cx="18" cy="18" r="8" fill="white"/>' +
      '</svg>';
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(36, 46),
      anchor: new google.maps.Point(18, 46)
    };
  }

  function init(config) {
    var stores = config.stores || [];
    var mapEl = document.getElementById(config.mapElementId);
    var cardsEl = document.getElementById(config.cardsContainerId);
    var searchEl = document.getElementById(config.searchId);
    var markerColor = config.markerColor || '#ee440e';

    if (!mapEl) return;

    var map = new google.maps.Map(mapEl, {
      center: config.center,
      zoom: config.zoom,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_BOTTOM }
    });

    var infoWindow = new google.maps.InfoWindow();
    var markers = [];
    var bounds = new google.maps.LatLngBounds();
    var validCount = 0;
    var iconNormal = buildMarkerIcon(markerColor);
    var iconActive = buildMarkerIcon('#1a1a1a');

    stores.forEach(function (store) {
      if (!store.lat || !store.lng) {
        markers.push(null);
        return;
      }
      var pos = { lat: store.lat, lng: store.lng };
      var marker = new google.maps.Marker({
        position: pos,
        map: map,
        title: store.name,
        icon: iconNormal
      });
      markers.push(marker);
      bounds.extend(pos);
      validCount++;

      marker.addListener('click', function () {
        activateStore(store.index, map, marker, infoWindow, store);
      });
    });

    if (validCount > 1) {
      map.fitBounds(bounds);
    }

    if (cardsEl) {
      cardsEl.querySelectorAll('.store-card').forEach(function (card) {
        card.addEventListener('click', function () {
          var idx = parseInt(card.dataset.index, 10);
          var store = stores[idx];
          var marker = markers[idx];
          if (store && marker) activateStore(idx, map, marker, infoWindow, store);
        });
      });
    }

    var activeFilter = 'all';

    function applyFilters() {
      var q = searchEl ? searchEl.value.toLowerCase().trim() : '';
      var cards = cardsEl ? cardsEl.querySelectorAll('.store-card') : [];
      var visible = 0;
      cards.forEach(function (card) {
        var nameMatch = !q ||
          (card.dataset.name || '').indexOf(q) !== -1 ||
          (card.dataset.city || '').indexOf(q) !== -1;
        var typeMatch = activeFilter === 'all' ||
          (card.dataset.type || '').toLowerCase() === activeFilter;
        var show = nameMatch && typeMatch;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      var noResults = cardsEl && cardsEl.querySelector('.store-locator__no-results');
      if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
      var countEl = config.countId ? document.getElementById(config.countId) : null;
      if (countEl) countEl.textContent = visible + ' retailer' + (visible !== 1 ? 's' : '') + ' found';
    }

    if (searchEl) {
      searchEl.addEventListener('input', applyFilters);
    }

    var filtersEl = config.filtersId ? document.getElementById(config.filtersId) : null;
    if (filtersEl) {
      filtersEl.querySelectorAll('.store-filter-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          filtersEl.querySelectorAll('.store-filter-btn').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          activeFilter = (btn.dataset.filter || 'all').toLowerCase();
          applyFilters();
        });
      });
    }

    function activateStore(idx, map, marker, infoWindow, store) {
      /* Reset all markers */
      markers.forEach(function (m) { if (m) m.setIcon(iconNormal); });
      marker.setIcon(iconActive);

      /* Highlight card */
      if (cardsEl) {
        cardsEl.querySelectorAll('.store-card').forEach(function (c) {
          c.classList.remove('is-active');
        });
        var activeCard = cardsEl.querySelector('.store-card[data-index="' + idx + '"]');
        if (activeCard) {
          activeCard.classList.add('is-active');
          activeCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      map.panTo(marker.getPosition());
      if (map.getZoom() < 13) map.setZoom(13);

      infoWindow.setContent(buildInfoContent(store));
      infoWindow.open(map, marker);
    }
  }

  /* Called by Google Maps callback after all section data is registered */
  function initAll() {
    var data = window.__storeLocatorData || {};
    Object.keys(data).forEach(function (sectionId) {
      init(data[sectionId]);
    });
  }

  return { init: init, initAll: initAll };
})();

/* Expose global callback for Google Maps async load */
window.initStoreLocatorMaps = function () {
  window.StoreLocator.initAll();
};
